// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-text{display:inline-block;max-width:100%;white-space:pre-wrap;word-wrap:break-word;vertical-align:middle;line-height:inherit}.lc-am-text.is-ellipsis{display:-webkit-box!important;-webkit-box-orient:vertical;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
module.exports = exports;
